import { cn } from '../../../../../lib/utils';
import { secondaryText } from '../../../../../styling/stylingHelper';
import type { FlaggedProduct } from '../../../../../services/admin/adminService';
import type { ReviewBucket } from '../../AuditReview';
import { KV, PlatformCopyCell, PromptCopyCell } from '../shared/copyCells';
import { formatQuantityInfo } from '../shared/quantityPrompt';
import type { TFn } from '../types';

// Card body for a single flagged quantity product.
function QtyCardBody({ p, t }: { p: FlaggedProduct; t: TFn }) {
  return (
    <div className="space-y-2 text-xs">
      <div className="text-orange-600 dark:text-orange-400">{p.reason}</div>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1 font-mono">
        <KV label={t('adminTesting.review.labelArticleId')} value={p.articleId || '-'} />
        <KV label={t('adminTesting.review.labelUnitPrice')} value={`€${p.unitPrice.toFixed(2)}`} />
        <KV label="Qty / Raw" value={`${p.quantity % 1 === 0 ? p.quantity : p.quantity.toFixed(3)} / ${p.rawQuantity}`} />
        <KV label={t('adminTesting.review.labelQuantityInfo')} value={formatQuantityInfo(p.quantityInfo)} />
      </div>
    </div>
  );
}

// Group flagged products into one review bucket per supplier (platform).
export function buildQuantityBuckets(
  products: (FlaggedProduct & { restaurantName?: string })[],
  t: TFn,
): ReviewBucket[] {
  const byPlatform = new Map<string, (FlaggedProduct & { restaurantName?: string })[]>();
  for (const p of products) {
    const arr = byPlatform.get(p.platform) ?? [];
    arr.push(p);
    byPlatform.set(p.platform, arr);
  }
  return Array.from(byPlatform.entries()).map(([platform, items]) => ({
    id: platform,
    title: platform,
    items: items.map((p, i) => ({
      id: `${platform}-${p.articleId}-${i}`,
      title: p.productName,
      subtitle: p.restaurantName,
      body: <QtyCardBody p={p} t={t} />,
      actions: (
        <>
          <span className={cn(secondaryText, 'text-xs')}>{t('adminTesting.review.copyFixPrompt')}</span>
          <PromptCopyCell product={p} />
          <span className={cn(secondaryText, 'text-xs ml-2')}>Gmail:</span>
          <PlatformCopyCell platform={p.platform} gmailId={p.gmailId} />
        </>
      ),
    })),
  }));
}
